export default "__VITE_ASSET__DbiGhIdY__"